import group from "./operations/undo_group";
import {selectAll} from "./operations/column_operations";
import {styleFormats} from "./toolbar/buttons";

export function init(view){
	const grid = view.$$("cells");
	const key = webix.env.isMac ? "command" : "ctrl";

	webix.UIManager.addHotKey(key+"-a", () => { if(!grid.getEditor()) selectAll(view); }, grid);
	webix.UIManager.addHotKey(key+"-p", (v, e) => dialog("print", view, e), grid);
	webix.UIManager.addHotKey(key+"-f", (v, e) => dialog("find", view, e), grid);
	webix.UIManager.addHotKey(key+"-h", (v, e) => dialog("find", view, e), grid);

	webix.UIManager.addHotKey(key+"-add", (v, e) => zoom(view, "in", e), grid);
	webix.UIManager.addHotKey(key+"-=", (v, e) => zoom(view, "in", e), grid);
	webix.UIManager.addHotKey(key+"-subtract", (v, e) => zoom(view, "out", e), grid);
	webix.UIManager.addHotKey(key+"-0", (v, e) => zoom(view, 1, e), grid);
	webix.UIManager.addHotKey(key+"-`", () => view.showFormulas("toggle"), grid);

	const scrollZoom = webix.event(grid.$view, "wheel", function(e){
		if (e.ctrlKey || e.metaKey) 
			zoom(view, e.deltaY < 0 ? "in" : "out", e);
	});
	view.attachEvent("onDestruct", () => webix.eventRemove(scrollZoom));

	if(!view.config.readonly){
		webix.UIManager.addHotKey("any", (view, ev) => {
			const code = ev.which || ev.keyCode;
			const f2 = code == 113;

			//ignore shift key, f1, f3 - f12 (f2 - edit)
			if (code == 16 || (code >= 112 && code <= 123 && !f2)) return;

			const sel = view.getSelectedId(true);
			if (sel.length){
				if(!(view.config.liveEditor && f2))
					grid.$anyKey = true;
				grid.edit(sel[0]);
			}
		}, grid);

		webix.UIManager.addHotKey("enter", (view) => {
			const sel = view.getSelectedId(true);
			if (sel.length){
				if(!(view.config.liveEditor && !grid.callEvent("onBeforeLiveEditor", [sel[0]])))
					grid.edit(sel[0]);
			}
		}, grid);

		webix.UIManager.addHotKey("backspace", () => del(view), grid);
		webix.UIManager.addHotKey("delete", () => del(view), grid);

		const redo = webix.env.isMac ? "command-shift-z" : "ctrl-y";
		webix.UIManager.addHotKey(redo, () => view.redo(), grid);
		webix.UIManager.addHotKey(key+"-z", () => view.undo(), grid);

		webix.UIManager.addHotKey(key+"-b", () => styleHotKey(view, "font-weight"), grid);
		webix.UIManager.addHotKey(key+"-i", () => styleHotKey(view, "font-style"), grid);
		webix.UIManager.addHotKey(key+"-u", (v, e) => ctrlU(view, e), grid);

		const strike = webix.env.isMac ? "command-shift-x" : "ctrl-alt-s";
		webix.UIManager.addHotKey(strike, () => styleHotKey(view, "strike"), grid);
	}
}

function del(view) {
	if(!view.$$("cells").getEditor())
		group.set(function(){
			view.eachSelectedCell((cell) => view.setCellValue(cell.row,cell.column, ""));
			view.refresh();
		});
}

function zoom(view, value, e) {
	view.zoom(value);
	return webix.html.preventEvent(e);
}

function ctrlU(view, e) {
	styleHotKey(view, "underline");
	return webix.html.preventEvent(e);
}

function dialog(id, view, e) {
	view.callEvent("onCommand",[{id}]);
	return webix.html.preventEvent(e);
}

function styleHotKey(view, attr) { 
	var cell = view.getSelectedId();
	if(cell){
		var style = view.getStyle(cell.row, cell.column);

		var elementOn = styleFormats[attr]||attr;
		var elementOff = "normal";

		var state = (style && style.props[attr] === elementOn)? elementOff : elementOn;
		view.callEvent("onStyleSet", [attr, state]);
	}
}